// extracted by mini-css-extract-plugin
export var button = "styles-module__button___czot5";
export var submit = "styles-module__submit___QpDPr";
export var outline = "styles-module__outline___x_3j4";
export var remove = "styles-module__remove___c5EGo";
export var text = "styles-module__text___Fg5gE";
export var appleLogin = "styles-module__appleLogin___mdPUQ";
export var facebookLogin = "styles-module__facebookLogin___WrSkf";
export var googleLogin = "styles-module__googleLogin___gNGpn";
export var facebookSettings = "styles-module__facebookSettings___ei6It";
export var contents = "styles-module__contents___RAsR1";
export var applePayIcon = "styles-module__applePayIcon___TToe8";
export var payPalIcon = "styles-module__payPalIcon___QRe63";
export var amazonPayIcon = "styles-module__amazonPayIcon____ApUj";
export var amazonPay = "styles-module__amazonPay___NQBpu";
export var appleCheckout = "styles-module__appleCheckout____KUGX";
export var payPalCheckout = "styles-module__payPalCheckout___qMXnY";
export var amazonCheckout = "styles-module__amazonCheckout___CYUE4";